import type { FC } from 'react'
import { SvgIconProps } from '@mui/material'

import { useFestiveVariants } from '@dhl/utils'

import { ParcelCatInTheBoxDefault } from './ParcelCatInTheBoxDefault.js'
import { ParcelCatInTheBoxEaster } from './ParcelCatInTheBoxEaster.js'

export const ParcelCatInTheBox: FC<SvgIconProps> = (props) => {
  const Component = useFestiveVariants({
    easter: ParcelCatInTheBoxEaster,
    default: ParcelCatInTheBoxDefault,
  })

  return <Component {...props} />
}
